import React from "react";
import ReactApexChart from "react-apexcharts";
import close from "./closebutton.png";
//import 'apexcharts/src/assets/styles.css'
// import { ScaleLoader} from 'react-spinners'

//  var colors = ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'];

export default class CChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selection: "all",
      coptions: {
        // colors:colors,
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        chart: {
          events: {
            beforeZoom: (e, { xaxis }) => {
              let maindifference =
                new Date(props.minimumDate).valueOf() -
                new Date(props.maximumDate).valueOf();
              console.log(maindifference);
              let zoomdifference = xaxis.max - xaxis.min;
              console.log(zoomdifference);
              if (zoomdifference > maindifference)
                return {
                  // dont zoom out any further
                  xaxis: {
                    min: new Date(props.minimumDate).getTime(),
                    max: new Date(props.maximumDate).getTime(),
                  },
                };
              else {
                return {
                  // keep on zooming
                  xaxis: {
                    min: xaxis.min,
                    max: xaxis.max,
                  },
                };
              }
            },
          },
          toolbar: {
            autoSelected: "pan",
            tools: {
              zoomout: false,
              zoom: false,
              customIcons: [
                {
                  icon: `<img src=${close} width="20" height="20"> `,
                  index: 4,
                  title: "close",
                  class: "custom-icon",
                  click: props.toggleVisibleGraphPanel,
                },
              ],
            },
          },
        },
        dataLabels: {
          enabled: false,

          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },
        stroke: {
          width: 5,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          title: {
            text: "",
          },
          tooltip: {
            enabled: false,
          },
          type: "datetime",
          //categories: this.props.categories,
          labels: {
            format: "dd MMM yyyy",
            style: {
              // colors: colors,
              fontSize: "14px",
            },
          },

          // min: new Date(this.props.maximumDate).getTime()-(24*60*60*1000) * 30,
          // max: new Date(this.props.maximumDate).getTime(),
        },
        tooltip: {
          theme: "dark",
          x: {
            format: "dd MMM yyyy",
          },
          y: {
            formatter: function (val) {
              // if(val===-0.0) return 'No Data'
              // else return val
              return val.toFixed();
            },
          },
        },
        yaxis: {
          title: {
            text: this.props.yAxisTitle,
          },
          labels: {
            formatter: function (val) {
              return val.toFixed();
            },
          },
        },
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
      },
    };
  }

  updateData = (timeline) => {
    this.setState({
      selection: timeline,
    });

    let maxdate = this.props.maximumDate;
    console.log(maxdate);
    var dateOffset_month = 24 * 60 * 60 * 1000 * 30; //30 days
    var dateOffset_week = 24 * 60 * 60 * 1000 * 7; //7 days
    var dateOffset_six = 24 * 60 * 60 * 1000 * 180; //30 days
    var dateOffset_twoweeks = 24 * 60 * 60 * 1000 * 14; //7 days

    // let days_30=maxdate.setDate(maxdate.getDate() - 30)
    // console.log(days_30)
    switch (timeline) {
      case "one_week":
        this.setState({
          coptions: {
            xaxis: {
              min: new Date(this.props.maximumDate).getTime() - dateOffset_week,
              max: new Date(this.props.maximumDate).getTime(),
            },
          },
        });
        break;
      case "two_weeks":
        this.setState({
          coptions: {
            xaxis: {
              min:
                new Date(this.props.maximumDate).getTime() -
                dateOffset_twoweeks,
              max: new Date(this.props.maximumDate).getTime(),
            },
          },
        });
        break;
      case "one_month":
        this.setState({
          coptions: {
            xaxis: {
              min:
                new Date(this.props.maximumDate).getTime() - dateOffset_month,
              max: new Date(this.props.maximumDate).getTime(),
            },
          },
        });
        break;
      case "six_months":
        this.setState({
          coptions: {
            xaxis: {
              min: new Date(this.props.maximumDate).getTime() - dateOffset_six,
              max: new Date(this.props.maximumDate).getTime(),
            },
          },
        });
        break;
      // case 'one_year':
      //   this.setState({
      //     options: {
      //       xaxis: {
      //         min: new Date('27 Feb 2012').getTime(),
      //         max: new Date('27 Feb 2013').getTime(),
      //       }
      //     }
      //   })
      //   break;
      // case 'ytd':
      //   this.setState({
      //     options: {
      //       xaxis: {
      //         min: new Date('01 Jan 2013').getTime(),
      //         max: new Date('27 Feb 2013').getTime(),
      //       }
      //     }
      //   })
      //   break;
      case "all":
        this.setState({
          coptions: {
            xaxis: {
              min: undefined,
              max: undefined,
            },
          },
        });
        break;
      default:
    }
  };

  render() {
    console.log(this.props.chartloading);
    console.log(this.props.maximumDate);
    // let coptions = {
    //         colors:colors,
    //         plotOptions: {
    //           bar: {
    //             dataLabels: {
    //               position: 'top', // top, center, bottom
    //             },
    //           }
    //         },
    //         dataLabels: {
    //           enabled: false,

    //           offsetY: -20,
    //           style: {
    //             fontSize: '12px',
    //             colors: ["#304758"]
    //           }
    //         },
    //        stroke:
    //        {
    //          width:5,
    //        },

    //         grid: {
    //           row: {
    //             colors: ['#fff', '#f2f2f2']
    //           }
    //         },
    //         xaxis: {
    //           title:{
    //           text: this.props.xAxisTitle
    //           },
    //             type:"datetime",
    //             //categories: this.props.categories,
    //             labels: {
    //               style: {
    //                 colors: colors,
    //                 fontSize: '14px'
    //               }
    //             }
    //           },
    //           tooltip: {
    //             x: {
    //               format: 'dd MMM yyyy'
    //             }
    //           },
    //         yaxis: {
    //           title: {
    //             text: this.props.yAxisTitle,
    //           },
    //         },
    //         crosshairs: {
    //           fill: {
    //             type: 'gradient',
    //             gradient: {
    //               colorFrom: '#D8E3F0',
    //               colorTo: '#BED1E6',
    //               stops: [0, 100],
    //               opacityFrom: 0.4,
    //               opacityTo: 0.5,
    //             }
    //           }
    //         },
    //       }

    let series = [
      {
        name: this.props.name,
        data: this.props.seriesData,
      },
    ];

    return (
      <ReactApexChart
        options={this.state.coptions}
        series={series}
        selection={this.state.selection}
        type={this.props.type}
        height="100%"
      />
    );
  }
}
